// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1sWaL","rootSuccess":"CompleteLink_rootSuccess__3f94V","rootFailure":"CompleteLink_rootFailure__9v9El","isDisabled":"CompleteLink_isDisabled__JHSU1"};